module.exports = flarum.core.compat['forum/states/DiscussionListState'];